import { memo } from 'react';

import Message from '~/Components/Message/Message';
import SearchPanel from '~/Components/SearchPanel/SearchPanel';
import { t } from '~/utils/localization';

import styles from './NotFound.scss';

const NotFound = () => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.content}>
        <div className={styles.search}>
          <SearchPanel />
        </div>
        <Message text={t('Player not found')} />
      </div>
    </div>
  );
};

export default memo(NotFound);
